<template>
  <div>
      <LoadingComponent v-show="checkLoading"></LoadingComponent>
      <v-container>
      <RoalertComponent v-show="error">
        <div>{{ errorMessage }}</div>
      </RoalertComponent>

      <h2 class="primary--text mb-4">Nowe konto pacjenta</h2>

      <div v-if="showPassword">
        <v-card>
          <v-card-text>
            <div class="pa-8">
              <h2 class="primary--text mb-6">Dziękujemy, konto pacjenta zostało utworzone.</h2>
              <p>{{ confirmationMessage }}</p>
            </div>
          </v-card-text>
        </v-card>
      </div>

      <template v-if="!showPassword">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
      <v-row class="mb-4">
        <v-col cols="12" xs="12" sm="6">
          <v-text-field
            v-model="hpot"
            name="email"
            label="e-mail"
            class="xpo"
            autocomplete="false"
          ></v-text-field>
          <v-text-field
            v-model="email"
            :rules="[rules.requiredEmail, rules.max50, rules.email]"
            label="e-mail*"
            name="xpe"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6">
          <v-text-field
            v-model="telefon"
            :rules="[rules.requiredTelefon, rules.telefon]"
            label="Telefon*"
            prefix="+48"
            counter=9
          ></v-text-field>
        </v-col>
      </v-row>
  <v-divider></v-divider>
      <v-row class="pt-4 mb-4">
        <v-col cols="12" xs="6" sm="6">
          <v-text-field
            v-model="imie"
            :rules="[rules.requiredImie, rules.max50, rules.imie]"
            label="Imię*"
          ></v-text-field>
        </v-col>

        <v-col cols="12" xs="12" sm="6">
          <v-text-field
            v-model="nazwisko"
            :rules="[rules.requiredNazwisko, rules.max50, rules.nazwisko]"
            label="Nazwisko*"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" xs="6" sm="3">
          <v-text-field
            v-model="pesel"
            :rules="isPeselRequired"
            :disabled="foreign"
            counter=11
            :label="checkPeselRequired"
            @change="changePesel"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="6" sm="3">
           <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dataur"
                label="Data urodzenia*"
                prepend-icon="mdi-calendar"
                :rules="[rules.required]"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              ref="picker"
              v-model="dataur"
              :max="new Date().toISOString().substr(0, 10)"
              min="1950-01-01"
              @change="save"
              locale="pl"
            first-day-of-week=1
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>

      <div>
        <v-checkbox
          v-model="foreign"
          label="Nie posiadam obywatelstwa polskiego"
          @change="checkForeign"
        ></v-checkbox>
        <v-row v-if="foreign">
          <v-col cols="12" xs="12" sm="6">
            <v-text-field
              v-model="passport"
              :rules="isPassportRequired"
              label="Seria i nr paszportu"
            ></v-text-field>
          </v-col>
        </v-row>
      </div>

      <v-divider></v-divider>

      <h4 class="pt-8">Adres zamieszkania</h4>
      <v-row>
        <v-col cols="12" xs="12" sm="6">
          <v-text-field
            v-model="ulica"
            :rules="[rules.required, rules.max50, rules.ulica]"
            label="Ulica*"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="6" sm="3">
          <v-text-field
            v-model="nrDomu"
            :rules="[rules.required, rules.ulica]"
            label="Nr domu*"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="6" sm="3">
          <v-text-field
            v-model="nrMieszkania"
            :rules="[rules.mieszkanie]"
            label="Nr mieszkania"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row class="mb-4">
        <v-col cols="12" xs="5" sm="2">
          <v-text-field
            v-model="kod"
            :rules="[rules.required, rules.kod]"
            label="Kod pocztowy*"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="7" sm="4">
          <MiastoComponent @city="handleCity" />
        </v-col>
      </v-row>

      <v-divider></v-divider>
      <div class="pt-4 mb-4 d-flex">
        <div style="max-width: 70px;">
        <v-checkbox
          v-model="zgoda1"
          :rules="[rules.zgodarequired]"
        ></v-checkbox>
        </div>
        <div><small v-html="zgodainfo"></small></div>
      </div>

       <v-row
          class="pt-8 pb-8"
        >
          <v-col class="text-right">

        <v-btn
          :disabled="!valid"
          elevation="0"
          border="bottom"
          tile
          color="success"
          @click="validatesend"
        >
          <v-icon left>
            mdi-check
          </v-icon>
          Utwórz konto
        </v-btn>

        </v-col>
        </v-row>


      </v-form>
      </template>

      </v-container>
  </div>
</template>

<script>
  import MiastoComponent from './MiastoComponent.vue';
  import RoalertComponent from './RoalertComponent.vue';
  import LoadingComponent from './LoadingComponent.vue';

  export default {
    name: 'NowypacjentComponent',
    components: {
      MiastoComponent,
      RoalertComponent,
      LoadingComponent,
    },
    data: () => ({
      email: '',
      hpot: '',
      telefon: '',
      imie: '',
      nazwisko: '',
      pesel: '',
      dataur: null,
      menu: false,
      foreign: false,
      passport: '',
      ulica: '',
      nrDomu: '',
      nrMieszkania: '',
      kod: '',
      miasto: null,
      isReady: false,
      url: document.querySelector('body').dataset.url,
      isPesel:false,
      checkLoading: false,
      zgoda1: false,
      zgodainfo: '',
      valid: true,
      peselrequired: true,
      showPassword: false,
      error: false,
      errorMessage: '',
      isPesel:false,
      confirmationMessage: '',

      rules: {
          max50: value => value.length <= 50 || 'Maksymalnie 50 znaków',
          requiredImie: value => !!value || 'Imię jest wymagane.',
          requiredNazwisko: value => !!value || 'Nazwisko jest wymagane.',
          requiredEmail: value => !!value || 'E-mail jest wymagany.',
          requiredTelefon: value => !!value || 'Telefon jest wymagany.',
          requiredPassport: value => !!value || 'Wymagany numer i seria paszportu',
          required: value => !!value || 'Pole jest wymagane.',
          zgodarequired: value => !!value || 'Zoda wymagana',
          safe() { return true; },
          mieszkanie: value => {
            if ( value === '') return true;
            const pattern = /^[0-9a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ \/\-\\\.\,\:]+$/;
            return pattern.test(value) || 'Użyto niedozwolony znak';
          },
          pesel: value => {
            if(!value) return true;
            const pattern = /^[[0-9]{11}$/;
            return pattern.test(value) || 'Błędny PESEL';
          },
          peselrequired: value => {
            const pattern = /^[[0-9]{11}$/;
            return pattern.test(value) || 'Nieprawidłowy PESEL';
          },
          telefon: value => {
            const pattern = /^[[0-9]{9}$/;
            return pattern.test(value) || 'Nieprawidłowy numer telefonu komórkowego';
          },
          kod: value => {
            const pattern = /^[0-9]{2}[-][0-9]{3}$/;
            return pattern.test(value) || 'Błędny kod pocztowy';
          },
          counter: value => value.length <= 20 || 'Max 20 characters',
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Nieprawidłowy e-mail.'
          },
          imie: value => {
            const pattern = /^[a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ \-]+$/;
            return pattern.test(value) || 'Imię zawiera niedozwolone znaki';
          },
          nazwisko: value => {
            const pattern = /^[a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ\- ]+$/;
            return pattern.test(value) || 'Nazwisko zawiera niedozwolone znaki';
          },
          ulica: value => {
            const pattern = /^[0-9a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ \/\-\\\.\,\:]+$/;
            return pattern.test(value) || 'Użyto niedozwolony znak';
          },

      },
    }),
    computed: {
      peselLabel() {
        if (this.peselrequired) return 'PESEL*';
        return 'PESEL';
      },
      checkPeselRequired() {
        if (this.isPesel) return 'PESEL*';
        return 'PESEL';
      },

      isPeselRequired() {
        if ((this.isPesel) && (!(this.foreign))) return [this.rules.peselrequired];
        return [this.rules.pesel];
      },
      isPassportRequired() {
        if (this.foreign) return [this.rules.requiredPassport, this.rules.max50];
        return [this.rules.max50];
      },
    },
    created() {
      const pes = parseInt(document.getElementById('nowekonto-main').getAttribute('data-pl'));
      if (this.isPesel) {
        console.log('P+');
      } else {
        console.log('P-');
      }
      this.isPesel = pes > 0;
      this.$api
        .getData(`/rejestracja/getzgodainfo`)
        .then(response => {
            this.zgodainfo = response.data;
          })
        .catch(error => console.log(error));
    },
    watch: {
      menu (val) {
        val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
      },
    },
    methods: {

      validatesend() {
        if (this.$refs.form.validate()) {
          this.startRegister();
        }
      },

      save (dataur) {
        this.$refs.menu.save(dataur)
      },

      changePesel() {
          this.loading = true;
          this.$api
          .getData(`/rejestracja/checkpesel?pesel=${this.pesel}`)
          .then(response => {
              this.dataur = response.data;
              this.loading = false;
            })
          .catch(error => console.log(error));
      },
      checkForeign() {
        this.$refs.form.resetValidation();
        if (this.foreign) this.pesel='';
        this.passport='';
      },
      handleCity(val) {
        this.miasto = val;
      },

      startRegister() {
        this.checkLoading = true;
        this.error = false;
        const data = {
          login: this.email,
          email: this.hpot,
          telefon: this.telefon,
          imie: this.imie,
          nazwisko: this.nazwisko,
          pesel: this.pesel,
          dataur: this.dataur,
          paszport: this.passport,
          kod: this.kod,
          ulica: this.ulica,
          nrdomu: this.nrDomu,
          nrmieszkania: this.nrMieszkania,
          miasto: this.miasto,
          foreign: this.foreign,
        };
        this.$api
        .postData(`/nowekonto/addpatient`, data)
        .then(response => {
            if(response.data.data.status=='ok') {
                this.checkLoading = false;
                this.confirmationMessage = response.data.data.message;
                this.showPassword = true;
            } else {
                this.checkLoading = false;
                this.error = true;
                this.errorMessage = response.data.data.message;
            }
        })
        .catch(error => console.log(error));
      },
    },
  }
</script>

<style lang="scss" scoped>
.v-label {display: inline-block !important}
.xpo {
  position: absolute !important; left: -500px !important;
}

</style>
